module.exports = __webpack_public_path__ + "static/media/contact-background.f48bd35f.png";